import { ClassNamesArg, css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  DatePicker as AriaDatePicker,
  DatePickerProps,
} from "react-aria-components";

export function _DatePicker(props: DatePickerProps<any>) {
  const style = css(styles.calendar);
  const className = cx(props.className as ClassNamesArg, style);

  return <AriaDatePicker {...mergeProps(props, { className })} />;
}

const styles = {
  calendar: css({
    display: "flex",
    flexDirection: "column",
    overflowX: "auto",
    // these are required at the top level, using data-open/focus-within at the
    // sub levels causes the styles to flicker when it swaps between states.
    "&[data-focus-within=true], &[data-open=true]": {
      "> div[role=group]": {
        boxShadow: "var(--focus-input)",
      },
    },
    "&[data-open=true]": {
      "div:nth-child(2)": {
        "> div > button": {
          backgroundColor: "var(--background-accent-tofino-strong)",
        },
        "* i[role=img]": {
          color: "var(--text-inverse)",
        },
      },
    },
  }),
};
